<div class="content__inner">
    <header class="content__title">
        <h1>{{ "interestedparties.list.title" | translate }}</h1>
        <small>{{ "interestedparties.list.subtitle" | translate }}</small>
    </header>

    <div class="card" *appHasPermission="'INTERESTEDPARTIES.LIST'">
        <div class="card-body">
            <h4 class="card-title">{{ "interestedparties.list.card.title" | translate }}</h4>

            <mat-form-field class="search-field">
                <mat-label>{{ "global.datatable.search" | translate }}</mat-label>
                <input matInput [formControl]="pageState.searchInputControl" [autocomplete]="'off'" />
            </mat-form-field>

            <!-- Table -->
            <div class="table-responsive">
                <table mat-table [dataSource]="dataSource" matSort (matSortChange)="announceSortChange($event)" [matSortActive]="pageState.sortState.active" [matSortDirection]="pageState.sortState.direction">
                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "interestedparties.props.name" | translate }}</th>
                        <td mat-cell *matCellDef="let row">{{ row.name }}</td>
                    </ng-container>

                    <ng-container matColumnDef="address">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "interestedparties.props.address" | translate }}</th>
                        <td mat-cell *matCellDef="let row">{{ row.address() }}</td>
                    </ng-container>

                    <ng-container matColumnDef="contact">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "interestedparties.props.contact" | translate }}</th>
                        <td mat-cell *matCellDef="let row">{{ row.contact() }}</td>
                    </ng-container>

                    <ng-container matColumnDef="notes">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "interestedparties.props.notes" | translate }}</th>
                        <td mat-cell *matCellDef="let row">{{ row.notes }}</td>
                    </ng-container>

                    <ng-container matColumnDef="created">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "interestedparties.props.created" | translate }}</th>
                        <td mat-cell *matCellDef="let row">{{ row.created | date:UTCDATEFORMAT }}</td>
                    </ng-container>

                    <ng-container matColumnDef="updated">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "interestedparties.props.updated" | translate }}</th>
                        <td mat-cell *matCellDef="let row">{{ row.updated | date:UTCDATEFORMAT }}</td>
                    </ng-container>

                    <ng-container matColumnDef="actions">
                        <th mat-header-cell *matHeaderCellDef></th>
                        <td mat-cell *matCellDef="let row">
                            <i (click)="deleteInterestedParty(row._id)" class="zmdi zmdi-delete zmdi-hc-fw tableIcon" *appHasPermission="'INTERESTEDPARTIES.DELETE'"></i>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                </table>
            </div>

            <mat-paginator
                class="flex inset-x-0 bottom-0 border-t border-b-0 z-10 bg-gray-50 dark:bg-transparent"
                #paginator
                [length]="pageState.totalRows"
                [pageIndex]="pageState.currentPage"
                [pageSize]="pageState.pageSize"
                [pageSizeOptions]="pageState.pageSizeOptions"
                showFirstLastButtons
                (page)="pageChanged($event)"
            >
            </mat-paginator>
        </div>
    </div>
</div>
